import { createPinia } from 'pinia';
import type { App } from 'vue';
import { createSentryPiniaPlugin } from '@sentry/vue';

export const store = createPinia();

store.use(createSentryPiniaPlugin());

export default function (app: App) {
    app.use(store);
}
